import { render } from "./closeIcon.vue?vue&type=template&id=2457ba50"
import script from "./closeIcon.vue?vue&type=script&lang=js"
export * from "./closeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__